import React, {Component} from "react"
import {Row, Col} from "@irati/ui/src/Layout"
import moment from "moment"

import {FormattedMessage, injectIntl, InjectIntl} from "@irati/utils/lang"
import {H2, H4} from "@irati/ui/src/Typography"
import DragAndDrop from "@irati/ui/src/DragAndDrop"
import Flex from "@irati/ui/src/Flex"
import businessService from "@irati/identity/services/business"
import intercom from "@irati/utils/intercom"
import authentication from "@irati/auth"
import Loading from "@irati/ui/src/Loading"
import Alert, {AlertTypes} from "@irati/ui/src/Alert"

import {CircledConnector} from "./styled"
import FieldsRecap from "./FieldsRecap"
import DownloadCsvTemplate from "./DownloadCsvTemplate"

interface Props extends InjectIntl {
  onDrop: (acceptedFiles?: any[]) => void
  back: () => void
}

interface State {
  load: Promise<any> | null
  showAlert: boolean
  licenses?: number
  startDate?: string
}

class AddPeopleCSV extends Component<Props, State> {
  state: State = {
    load: null,
    showAlert: false,
    licenses: undefined,
    startDate: undefined
  }

  componentDidMount() {
    const load = businessService
      .getBusinessRestrictions(authentication.business().uuid, {fetchPolicy: "network-only"})
      .then(({hasMaxUserLimit, maxUsersLimit}) => {
        if (hasMaxUserLimit) {
          this.setState({
            showAlert: hasMaxUserLimit,
            licenses: maxUsersLimit,
            startDate: moment(authentication.business().metadata?.createdAt).add(30, "days").format("DD/MM/YYYY")
          })
        }
      })
    this.setState({load})
  }

  handleSuport = () => {
    intercom.addCustomMessage("")
  }

  render() {
    const {onDrop, formatMessage} = this.props
    const {load, showAlert, licenses, startDate} = this.state

    return (
      <Loading load={load}>
        <Flex justifyContent="flex-start" direction="column">
          <H2 marginBottom={4}>
            <FormattedMessage id="admin.components.addPeopleCSV.headerTwo" />
          </H2>
          {showAlert && (
            <Alert
              type={AlertTypes.warning}
              title="admin.components.addPeopleCSV.showAlertRestrictions.title"
              values={{licenses, startDate}}
              link="admin.components.addPeopleCSV.showAlertRestrictions.link"
              onClickLink={this.handleSuport}
              onHide={() => this.setState({showAlert: false})}
            />
          )}
          <H4 marginBottom={2}>
            <FormattedMessage id="admin.components.addPeopleCSV.headerFour.text" />
          </H4>
          <CircledConnector
            data={[
              "renderCompFromProps",
              formatMessage({id: "admin.components.addPeopleCSV.circledConnector.data.fillInformation"}),
              formatMessage({id: "admin.components.addPeopleCSV.circledConnector.data.dragAndDrop"})
            ]}
            comp={<DownloadCsvTemplate />}
          />
          <Row>
            <Col md={12}>
              <DragAndDrop onDrop={onDrop} />
              <FieldsRecap addUsers />
            </Col>
          </Row>
        </Flex>
      </Loading>
    )
  }
}

export default injectIntl(AddPeopleCSV)
